﻿/**
* @desc the ngProductBookingInfo provides support for displaying the fligth details in templates 
* @example <div ng-product-booking-info ng-repeat="itinerary in view.itineraries" index="$index+1" product="itinerary" cities="view.cities" airlines="view.airlines" airports="view.airports" equipments="view.equipments" cabinclasses="view.cabinClasses" requestcabinclass="currentCabinClass"></div>
*/

webClient.directive('ngItineraryBookingInfo', ['$window', '$i18next', 'templateService', function ($window, $i18next, templateService) {
    var directive = {};
    directive.restrict = 'EA';
    directive.scope = {
        product: "=",
        summary: "=",
        index: "=",
        triptype: "=",
        requestcabinclass: "=",
        cabinclasses: "=",
        ispoductto: "=",
        showbaggages: "=",
        bookingdata: "="
    };
    directive.link = function ($scope, $element) {

        templateService.compile($scope, $element, 'tpl/_BookingItineraryTPL.html');

        //Initialize Variables
        $scope.getUrl = $window.getUrl;
        $scope.index = $scope.index + 1;
        $scope.siteType = $window.site.type;
        $scope.getTemplateUrl = $window.getTemplateUrl;
        $scope.getStaticFolder = $window.getStaticFolder;
        $scope.getGlobalStaticFolder = $window.getGlobalStaticFolder;
        $scope.getTypeStaticFolder = $window.getTypeStaticFolder;
        $scope.enableOption = $window.enableOption && !($window.sessionStorage.getItem('forceUpsell') === 'true' || $window.getUrlVars()['upsell'] === 'true');
        $scope.isProductTO = $scope.siteType == 2 && $scope.ispoductto; //TO Product: if site is b2b and product is TO        
        $scope.addBagText = "";
        $scope.isMasStock = $scope.bookingdata.purchaseResponse.masstock;

        //console.log("PRODUCT");
        //console.log($scope.product);

        var segStops = 0;

        $scope.product.segments.each(function (seg) {
            segStops += seg.stops;
        });

        $scope.stops = $scope.product.stops >= segStops ? $scope.product.stops : segStops;

        //Prepare baggages wording
        $scope.prepareItineraryWordings = function (fares) {
            $scope.baggaggeDisplayText = [];
            if (fares != null) {
                fares.each(function (f) {
                    f.itineraries.each(function (i) {
                        if (i.key == $scope.product.key) {
                            if (i.baggageQuantity > 0) {
                                var paxTypes = [];
                                paxTypes[0] = $i18next.t('airbooking.ad'); //Adulte
                                paxTypes[1] = $i18next.t('airbooking.enf'); //enfant
                                paxTypes[2] = $i18next.t('loadingpage.infants'); //Bebe
                                if (i.baggageWeight == null || i.baggageWeight == undefined || i.baggageWeight <= 0)
                                    $scope.baggaggeDisplayText.push(($i18next.t('airbooking.bagageensoute2')+" ").format(i.baggageQuantity, i.baggageQuantity > 1 ? "s" : "", paxTypes[f.paxType]));
                                else if (i.baggageWeight > 0)
                                    $scope.baggaggeDisplayText.push(($i18next.t('airbooking.kgperone')+"").format(i.baggageWeight, paxTypes[f.paxType]));
                            }
                        }
                    })
                })
            }
            if ($scope.baggaggeDisplayText.length == 0)
                $scope.baggaggeDisplayText.push($i18next.t('airbooking.paxsresume.nobaggages'));

            return $scope.baggaggeDisplayText.join(" | ");
        };

        //Prepare Itinerary Info
        $scope.updateItineraryInfo = function () {
            $scope.bagDisplayText = "";
            $scope.adultFare = {};
            $scope.fareItineraryAdult = {};
            $scope.fareItineraryAdult.segments = {};
            var fares = $window.objectClone($scope.bookingdata.purchaseResponse.proposalsRequested.fares);
            $scope.adultFare = fares.first(function (x) { return x.paxType == 0 });
            $scope.fareItineraryAdult = $scope.adultFare.itineraries.first(function (x) { return x.key == $scope.product.key });

            if ($scope.fareItineraryAdult) {
                $scope.fareItineraryAdultSegments = $scope.fareItineraryAdult.segments.groupByKey("key");
                $scope.bagDisplayText = $scope.prepareItineraryWordings($scope.bookingdata.purchaseResponse.proposalsRequested.fares);
            }
            else
                console.log("No itineraries with the product key");
        };

        $scope.updateItineraryInfo();

        $scope.getText = function (key) {
            return $window.culture.texts[key];
        };

        $scope.inboundVisibleFilter = function (item) {
            return item.visible;
        };

        $scope.showRetour = false;

        $scope.ffdet = function (idx) {
            $scope.showDetails = !$scope.showDetails;
            $window.FFDet(idx);
        };

        $scope.fsmoothopen = function (_oOpener, _iSmooth, _iToggle, _vToggleClass) {
            if (_oOpener.target)
                _oOpener = _oOpener.target;
            var obj = { oOpener: _oOpener, iSmooth: _iSmooth };
            if (_iToggle) obj.iToggle = _iToggle;
            if (_vToggleClass) obj.vToggleClass = _vToggleClass;
            $window.FSmoothOpen(obj);
        };

        //cabin class
        $scope.alertCabinClass = function (segmentCabinClass) {
            if ($scope.requestcabinclass == segmentCabinClass)
                return true;

            if ($scope.requestcabinclass === "C")
                if (segmentCabinClass === "C" || segmentCabinClass === "J") return true;

            if ($scope.requestcabinclass === "F")
                if (segmentCabinClass === "F" || segmentCabinClass === "P") return true;

            return false;
        };


        if ($scope.product.additionalBaggages 
            && $scope.product.additionalBaggages.length > 1
            && $scope.product.additionalBaggages.any(function (b) { return b.location === 0; })
            && $scope.product.additionalBaggages.filter(function (b) { return b.location === 0; })[0].description 
            && $scope.product.additionalBaggages.filter(function (b) { return b.location === 0; })[0].description.indexOf(':') > 0) {

            var bag = $scope.product.additionalBaggages.filter(function (b) { return b.location === 0; })[0];

            $scope.addBagText = "\r\n" + $i18next.t('airbooking.possibleluggage') + " " + bag.description.substring(bag.description.indexOf(':') + 1);
        }
        else {
            $scope.addBagText = "\n\r" + $i18next.t('airbooking.luggage.notonline1') + "\n\r" + $i18next.t('airbooking.luggage.notonline2');
        }

        $scope.toHtml = function (text) {
            return text.replaceAll('\n\r', '<br/>');
        };

        //onItinerarySummaryUpdate
        $scope.$on("onItinerarySummaryUpdate", function (event, args) {
            $scope.updateItineraryInfo();
        });
    };
    return directive;
}]);
